import type { FaireProductEntity } from "../../entity_types/product";

export const p_jaxunnpyqz: FaireProductEntity = {
  token: "p_jaxunnpyqz",
  type: "product",
  name: "pink bouquet mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/522f49eb26e1f43bdb3134c08f90ebe837e80c49f49edd4686a27285b311564b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15740c5055a933426a92b7857412cc2a7197a6b0656a77ab83bbd4401761966f.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- printed on 120lb paper\n- original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:48.202Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
